import { type ResourceKeysStructure } from '../main';
import type defaultResources from './common.cs';

export default {
	'close.label': 'Schließen',
	'yes.label': 'Ja',
	'no.label': 'Nein',
	language: {
		label: 'Unbekannt',
		label_1: 'Tschechisch',
		label_2: 'Slowakisch',
		label_3: 'Englisch',
		label_4: 'Deutsch',
		label_5: 'Französisch',
		label_6: 'Spanisch',
		label_7: 'Russisch',
		label_8: 'Norwegisch',
		label_9: 'Schwedisch',
	},
	chipType: {
		label: 'Unbekannt',
		label_1: 'Normaler Chip',
		label_2: 'Online aufgeladener Chip',
		label_3: 'VIP-Chip',
		label_4: 'Anonyme Transaktion',
		label_5: 'Mitarbeiter-Chip',
		label_6: 'Gast-Chip',
	},
	country: {
		label: 'Unbekannt',
		label_1: 'Tschechische Republik',
		label_2: 'Slowakei',
		label_3: 'Österreich',
		label_4: 'Vereinigtes Königreich',
		label_5: 'Serbien',
		label_6: 'Belgien',
		label_7: 'Bulgarien',
		label_8: 'Kroatien',
		label_9: 'Zypern',
		label_10: 'Dänemark',
		label_11: 'Estland',
		label_12: 'Finnland',
		label_13: 'Frankreich',
		label_14: 'Deutschland',
		label_15: 'Griechenland',
		label_16: 'Ungarn',
		label_17: 'Irland',
		label_18: 'Italien',
		label_19: 'Lettland',
		label_20: 'Litauen',
		label_21: 'Luxemburg',
		label_22: 'Malta',
		label_23: 'Polen',
		label_24: 'Portugal',
		label_25: 'Rumänien',
		label_26: 'Slowenien',
		label_27: 'Spanien',
		label_28: 'Schweden',
		label_29: 'Niederlande',
		label_30: 'Island',
		label_31: 'Liechtenstein',
		label_32: 'Norwegen',
		label_33: 'Schweiz',
	},
	currency: {
		label: 'Unbekannt',
		label_1: 'Tschechische Krone',
		label_2: 'Euro',
		label_3: 'Serbischer Dinar',
		label_4: 'Britisches Pfund',
		label_5: 'Polnischer Zloty',
	},
	reqProvider: {
		label: 'Unbekannt',
		label_1: 'E-Mail',
		label_2: 'Facebook',
		label_3: 'Google',
		label_4: 'Apple',
	},
	eventCategory: {
		label: 'Unbekannt',
		label_1: 'Musik',
		label_2: 'Gastronomie',
		label_3: 'Kultur',
		label_4: 'Wein',
		label_5: 'Sport',
		label_6: 'Serienveranstaltung',
		label_7: 'Festival',
		label_8: 'Kinder',
		label_9: 'Party',
		label_10: 'Theater',
		label_11: 'Konzert',
		label_12: 'Bier',
	},
	eventKind: {
		label: 'Unbekannt',
		label_1: 'Einmalige Veranstaltung',
		label_2: 'Langfristiger Betrieb',
	},
	eventSize: {
		label: 'Unbekannt',
		label_1: 'Klein',
		label_2: 'Mittel',
		label_3: 'Groß',
	},
	eventType: {
		label: 'Unbekannt',
		label_1: 'Tickets',
		label_2: 'Pakete',
		label_3: 'Guthaben aufladen',
	},
	itemType: {
		label: 'Unbekannt',
		label_1: 'Veranstaltungseintritt',
		label_2: 'Parken',
		label_3: 'NFC-Chip',
		label_4: 'Attraktionseintritt',
		label_5: 'Workshop',
		label_6: 'Produkt',
		label_7: 'Wiederholter Veranstaltungseintritt',
		label_8: 'NFC-Chip VIP',
		label_9: 'Zone',
	},
	paymentMethod: {
		label: 'Unbekannt',
		label_1: 'Kreditkarte',
		label_2: 'Banküberweisung',
		label_3: 'Google Pay',
		label_4: 'Apple Pay',
		label_5: 'Mobiles Terminal',
		label_6: 'Bargeld',
		label_7: 'Chip',
		label_8: 'VIP-Chip',
		label_9: 'Tickets-Gutschein',
		label_10: 'Partner',
		label_11: 'Click To Pay',
	},
	productCategory: {
		label: 'Unbekannt',
		label_1: 'Alkoholfrei',
		label_2: 'Bier',
		label_3: 'Wein',
		label_4: 'Sonstiger Alkohol',
		label_5: 'Salziges',
		label_6: 'Süßes',
		label_7: 'Zusätzliches Sortiment',
	},
	region: {
		label: 'Unbekannt',
		label_1: 'Hauptstadt Prag',
		label_2: 'Mittelböhmen',
		label_3: 'Südböhmen',
		label_4: 'Pilsen',
		label_5: 'Karlsbad',
		label_6: 'Aussig',
		label_7: 'Reichenberg',
		label_8: 'Königgrätz',
		label_9: 'Pardubitz',
		label_10: 'Hochland',
		label_11: 'Südmähren',
		label_12: 'Olmütz',
		label_13: 'Zlín',
		label_14: 'Mährisch-Schlesien',
		label_201: 'Bratislava',
		label_202: 'Trnava',
		label_203: 'Trenčín',
		label_204: 'Nitra',
		label_205: 'Žilina',
		label_206: 'Banská Bystrica',
		label_207: 'Prešov',
		label_208: 'Košice',
		label_301: 'Wien',
		label_302: 'Niederösterreich',
		label_303: 'Oberösterreich',
		label_304: 'Steiermark',
		label_305: 'Kärnten',
		label_306: 'Burgenland',
		label_307: 'Salzburg',
		label_308: 'Tirol',
		label_309: 'Vorarlberg',
		label_501: 'Vojvodina',
		label_502: 'Belgrad',
		label_503: 'Kosovo',
		label_504: 'Metochien',
		label_505: 'Šumadija und Westliches Serbien',
		label_506: 'Südliches und Östliches Serbien',
		label_1501: 'Attika',
		label_1502: 'Mittelgriechenland',
		label_1503: 'Zentralmakedonien',
		label_1504: 'Kreta',
		label_1505: 'Ostmakedonien und Thrakien',
		label_1506: 'Epirus',
		label_1507: 'Ionische Inseln',
		label_1508: 'Nordägäis',
		label_1509: 'Peloponnes',
		label_1510: 'Südägäis',
		label_1511: 'Thessalien',
		label_1512: 'Westgriechenland',
		label_1513: 'Westmakedonien',
		label_1401: 'Baden-Württemberg',
		label_1402: 'Bayern',
		label_1403: 'Berlin',
		label_1404: 'Brandenburg',
		label_1405: 'Bremen',
		label_1406: 'Hamburg',
		label_1407: 'Hessen',
		label_1408: 'Niedersachsen',
		label_1409: 'Mecklenburg-Vorpommern',
		label_1410: 'Nordrhein-Westfalen',
		label_1411: 'Rheinland-Pfalz',
		label_1412: 'Saarland',
		label_1413: 'Sachsen',
		label_1414: 'Sachsen-Anhalt',
		label_1415: 'Schleswig-Holstein',
		label_1416: 'Thüringen',
	},
	sectionType: {
		label: 'Unbekannt',
		label_1: 'Beliebt',
		label_2: 'Unsere Auswahl',
		label_3: 'Aktuell',
		label_4: 'Dieses Wochenende',
		label_5: 'Gerade angekündigt',
		label_6: 'Spezial',
		label_7: 'In meiner Nähe',
	},
	venueType: {
		label: 'Unbekannt',
		label_1: 'Stadion',
		label_2: 'Camp',
		label_3: 'Wiesengelände',
		label_4: 'Freilichttheater/Kino',
		label_5: 'Theater/Kino',
		label_6: 'Stadt',
		label_7: 'Musikclub',
	},
} as const satisfies ResourceKeysStructure<typeof defaultResources>;
